import PropTypes from 'prop-types';
import { Badge, Button } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import InputFormGroup from '../util/InputFormGroup';
import StateFormGroup from './StateFormGroup';
import useTheme from '../hooks/useTheme';
import { useBillingProfileFormHandlers } from './useBillingProfileFormHandlers';

function BillingProfileForm({ data, onComplete, onCancel }) {
  const { handleSubmit, handleCancel, errorMsg } =
    useBillingProfileFormHandlers(onComplete, onCancel);
  const [theme] = useTheme();

  if (!data || !data.billingProfile || !data.countryValidationRules) {
    return null;
  }

  const { billingProfile } = data;
  const { countryValidationRules } = data;

  const {
    postalCodePattern,
    phoneNumberPattern,
    isStateRequired,
    supportedStatesList,
  } = countryValidationRules;

  return (
    <>
      <br />
      <div>
        To properly set up your Skype Outlook Scheduling ability, we must first
        create a billing profile.
      </div>
      <Badge variant="danger">{errorMsg}</Badge>
      <Formik
        initialValues={{
          firstName: billingProfile.defaultAddress.firstName || '',
          lastName: billingProfile.defaultAddress.lastName || '',
          companyName: billingProfile.companyName || '',
          email: billingProfile.email || '',
          phoneNumber: billingProfile.defaultAddress.phoneNumber || '',
          addressLine1: billingProfile.defaultAddress.addressLine1 || '',
          addressLine2: billingProfile.defaultAddress.addressLine2 || '',
          city: billingProfile.defaultAddress.city || '',
          state: billingProfile.defaultAddress.state || '',
          postalCode: billingProfile.defaultAddress.postalCode || '',
        }}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <br />
            <InputFormGroup
              name="firstName"
              label="First Name"
              pattern=".{1,50}"
              title="Between 1 and 50 word characters"
              required
            />
            <InputFormGroup
              name="lastName"
              label="Last Name"
              pattern=".{1,50}"
              title="Between 1 and 50 word characters"
              required
            />
            <InputFormGroup
              name="companyName"
              label="Company Name"
              pattern=".{1,50}"
              title="Between 1 and 50 word characters"
              required
            />
            <InputFormGroup
              type="email"
              name="email"
              label="Email Address"
              pattern=".{1,255}"
              title="Between 1 and 255 word characters"
              required
            />
            <InputFormGroup
              name="phoneNumber"
              label="Phone Number"
              pattern={phoneNumberPattern}
              title="Between 1 and 20 numbers"
              required
            />
            <InputFormGroup
              name="addressLine1"
              label="Address Line 1"
              pattern=".{1,50}"
              title="Between 1 and 50 word characters"
              required
            />
            <InputFormGroup
              name="addressLine2"
              label="Address Line 2"
              pattern=".{1,50}"
              title="Between 1 and 50 word characters"
            />
            <InputFormGroup
              name="city"
              label="City"
              pattern=".{1,50}"
              title="Between 1 and 50 word characters"
              required
            />
            <StateFormGroup
              isStateRequired={isStateRequired}
              supportedStatesList={supportedStatesList}
            />
            <InputFormGroup
              name="postalCode"
              label="Zip/Postal code"
              pattern={postalCodePattern}
              title="Between 1 and 10 numbers"
              required
            />

            <Button
              style={{ marginRight: '.15em' }}
              type="submit"
              variant={theme?.buttonVariant}
              size="lg"
              disabled={isSubmitting}
            >
              SUBMIT
            </Button>
            <Button
              variant={theme?.buttonVariant}
              size="lg"
              onClick={handleCancel}
            >
              CANCEL
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
}

BillingProfileForm.propTypes = {
  data: PropTypes.object,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func,
};

export default BillingProfileForm;
